import { Typography } from '@atlas-metrics/design-system';
import { Trans, useTranslation } from 'next-i18next';
import * as React from 'react';

import IconCircle from './ui/IconCircle';

export default function NoData() {
  const { t } = useTranslation();

  return (
    <div className='layout my-10 flex flex-col items-center justify-center text-center text-black'>
      <IconCircle
        iconClassName='text-ds-grey-500'
        icon='icon-barcode'
        className='mb-8'
      />
      <Typography variant='h4' className='mb-4 tracking-wide'>
        {t('no-data.title')}
      </Typography>
      <Typography variant='body-l' className='text-center text-ds-grey-700'>
        <Trans i18nKey='no-data.description' />
      </Typography>
    </div>
  );
}
